export const FETCH_INITIATIVES = 'fetch_initiatives'
